export enum VerifyAddressValidationErrorMessage {
  PO_BOX = 'PO Box address is not allowed',
  INVALID_STATE = 'Invalid state',
  INVALID_ZIP = 'Zip code must be 5 or 9 digits',
}
